<template>
  <span>
  <b-badge pill :variant="tag_variant" class="py-1 px-3 my-1">{{ order.tag }}</b-badge>
  <b-badge v-if="order.transaction_status == 'UNPAID'" pill variant="warning" class="my-1 py-1 px-3">
    Balance Due
  </b-badge>
  <b-badge v-else-if="order.transaction_status == 'PAYMENT_CREDIT'" pill variant="warning" class="my-1 py-1 px-3">
    {{ order.status_desc }} with Credit Due
  </b-badge>
  <b-badge v-if="order.status == 'P' && order.pick_date" variant="success" pill class="my-1 py-1 px-3">
    PICKED
  </b-badge>
  </span>
</template>

<script>
export default {
  name: "order-pill",
  props: {
    order: Object
  },
  computed: {
    tag_variant() {
      const tag = this.order.tag
      if (tag == 'MINE')
        return 'secondary';
      else if (tag == 'RUSH')
        return 'warning';
      else if (tag == 'HOLD')
        return 'secondary';
      else if (tag == 'LOCAL')
        return 'info';
      else if (tag == 'LATE')
        return 'danger';
      else
        return null;
    }
  }
}
</script>

<style scoped>

</style>